import { getTimeBasedGreeting } from "../../utils/format";

type PersonalizedGreetingProps = {
  userName: string;
};

export function PersonalizedGreeting({ userName }: PersonalizedGreetingProps) {
  const greeting = getTimeBasedGreeting();
  const firstName = userName?.split(" ")[0] || "there";

  return (
    <div class="mb-1">
      <h1 class="text-[1.625rem] font-bold text-text leading-tight tracking-[-0.01em]">
        {greeting}, {firstName}
      </h1>
      <p class="text-sm text-text-muted mt-1.5">
        Here's what needs your attention.
      </p>
    </div>
  );
}
